import React from 'react';
import SEO from '../components/SEO';

const Terms: React.FC = () => {
  return (
    <div className="pt-24 pb-16">
      <SEO title="Syarat & Ketentuan" description="Syarat dan ketentuan penggunaan XCape." />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Syarat & Ketentuan</h1>
        <p className="text-slate-500 mb-8">Terakhir diperbarui: 22 Desember 2024</p>

        <h3>1. Penerimaan Syarat</h3>
        <p>Dengan mengunduh atau menggunakan XCape, Anda menyetujui syarat dan ketentuan ini sepenuhnya.</p>

        <h3>2. Lisensi Penggunaan</h3>
        <p>Kami memberikan Anda lisensi terbatas, non-eksklusif, dan tidak dapat dipindahtangankan untuk menggunakan aplikasi ini untuk keperluan pribadi.</p>

        <h3>3. Batasan Tanggung Jawab</h3>
        <p>XCape disediakan "sebagaimana adanya". Kami tidak bertanggung jawab atas konsekuensi langsung atau tidak langsung dari penggunaan aplikasi ini, termasuk namun tidak terbatas pada sanksi administratif dari tempat kerja Anda.</p>
        
        <h3>4. Penggunaan yang Dilarang</h3>
        <p>Anda dilarang menggunakan aplikasi ini untuk tujuan ilegal, penipuan, atau tindakan yang melanggar hukum di yurisdiksi Anda.</p>
      </div>
    </div>
  );
};

export default Terms;